import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import PageHero from "../components/PageHero";
import { PROGRAMS } from "../lib/site";

export default function Programs() {
  return (
    <>
      <PageHero
        label="Signature Programs"
        title={<>Programs designed for <em className="font-serif italic gold-text">every chapter</em> of growth.</>}
        subtitle="Three signature journeys, each engineered around developmental milestones — from a child's very first joyful word on stage to the assured public address of a young leader."
      />

      {PROGRAMS.map((p, i) => (
        <section
          key={p.slug}
          data-testid={`program-section-${p.slug}`}
          className={`py-24 lg:py-32 ${i % 2 === 1 ? "bg-[#080808] border-y border-white/5" : ""}`}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
            <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <Reveal>
                <div className="relative overflow-hidden aspect-[5/4]">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-black/30" />
                  <div className="absolute top-6 left-6 section-label bg-black/70 backdrop-blur px-3 py-1">
                    {p.ageGroup}
                  </div>
                  <div className="absolute bottom-6 left-6 font-serif text-6xl gold-text opacity-90">
                    0{i + 1}
                  </div>
                </div>
              </Reveal>
            </div>

            <div className="lg:col-span-6">
              <Reveal delay={0.1}>
                <SectionLabel>{p.ageGroup}</SectionLabel>
                <h2 className="mt-6 font-serif text-4xl lg:text-5xl font-light text-white leading-[1.05]">
                  {p.title}
                </h2>
                <p className="mt-6 font-sans text-base lg:text-lg text-white/65 leading-relaxed">
                  {p.overview}
                </p>

                <div className="mt-9 grid sm:grid-cols-2 gap-8">
                  <div>
                    <h4 className="section-label">Learning Outcomes</h4>
                    <ul className="mt-4 space-y-3">
                      {p.outcomes.map((o) => (
                        <li key={o} className="flex items-start gap-3 font-sans text-sm text-white/70">
                          <Check size={15} className="text-[#d4af37] mt-1 shrink-0" />
                          {o}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h4 className="section-label">Benefits</h4>
                    <ul className="mt-4 space-y-3">
                      {p.benefits.map((b) => (
                        <li key={b} className="flex items-start gap-3 font-sans text-sm text-white/70">
                          <Check size={15} className="text-[#d4af37] mt-1 shrink-0" />
                          {b}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <Link
                  to="/join"
                  data-testid={`program-cta-${p.slug}`}
                  className="mt-10 inline-flex btn-gold font-sans text-[11px] tracking-[0.3em] uppercase px-8 py-4 items-center gap-3"
                >
                  Enquire About {p.title} <ArrowUpRight size={14} />
                </Link>
              </Reveal>
            </div>
          </div>
        </section>
      ))}
    </>
  );
}
